<template>
  <section class="content">
    <div class="row center-block">
      <div class="box">
        <div class="box-header">
          <h3 class="box-title">Add Maker</h3>
        </div>
        <div class="box-body">
          <form @submit.prevent>
            <div class="modal-body test col-md-12">
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1">Name <b>*</b></label>
                <input
                  type="text"
                  v-model="Name"
                  required
                  class="form-control"
                  placeholder="Enter Name"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1">Has Subtype <b>*</b></label>
                <select class="form-control" v-model="Subtype" required>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1">File <b>*</b></label>
                <input
                  type="file"
                  id="file"
                  ref="file"
                  class="form-control"
                  accept="image/*"
                  required
                  v-on:change="handleFileUpload()"
                />
              </div>
            </div>

            <div class="modal-footer test">
              <button
                type="submit"
                class="btn btn-primary"
                v-on:click="AddMaker()"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="row center-block">
      <div class="box">
        <div class="box-body">
          <div
            class="dataTables_wrapper form-inline dt-bootstrap"
            id="example1_wrapper"
          >
            <div class="row">
              <div class="col-sm-6">
                <div id="example1_length" class="dataTables_length"></div>
              </div>
            </div>

            <div class="row box-body">
              <div class="col-sm-12 table-responsive" id="Feedbacks">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example"
                  style="width: 100%;"
                  class="display table table-bordered table-striped dataTable wrap"
                >
                  <thead>
                    <tr role="row">
                      <th>No</th>
                      <th>Name</th>
                      <th>Image</th>
                      <th>Has Type</th>
                      <!-- <th>Data</th> -->
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="(S, index) in Makers">
                      <td class="sorting_1">{{ index + 1 }}</td>
                      <td class="sorting_1">{{ S.name }}</td>
                      <td class="sorting_1">
                        <img
                          :src="S.imageUrl"
                          :alt="S.name"
                          width="100"
                          height="100"
                          @click="changeImage(S,'logo'+index)"
                        />
                        <input
                          type="file"
                          :ref="'logo'+index"
                          :id="'logo'+index"
                          class="form-control"
                          accept="image/*"
                          style="display:none"
                          v-on:change="changeLogo(S, 'logo'+index)"
                        />
                      </td>
                      <td class="sorting_1">{{ S.hasType }}</td>
                      <!-- <td class="sorting_1 td-max-width">{{S.Data.ciphertext.toString()}}</td> -->
                      <td>
                        <button
                          type="submit"
                          class="btn btn-outline-delete"
                          v-on:click="DeleteFile(S)"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";

import { globalStore } from "../../main.js";

// Require needed datatables modules
require("datatables.net");
require("datatables.net-bs");

var aesjs = require("aes-js");
var eccrypto = require("eccrypto");

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      Name: "",
      Subtype: "no",
      file: "",
      fileType: "",
      fileName: "",
      Makers: [],
      token: JSON.parse(localStorage.getItem("token")),
    };
  },
  mounted() {
    // console.log("token", this.token);
    this.getAllMakers();
  },
  computed: {},
  methods: {
    async handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.fileType = this.file.type;
      this.fileName = this.file.name;
      console.log("this.file", this.file);
      console.log("this.file", this.fileType);
      console.log("this.file", this.fileName);
      // this.Text = await this.toBase64(this.file);
      // console.log(await this.toBase64(this.file));
    },
    async AddMaker() {
      let formData = new FormData();
      formData.append("name", this.Name);
      formData.append("hasType", this.Subtype);
      formData.append("photo", this.$refs.file.files[0]);

      console.log("formData", formData);
      let headers = {
        headers: {
          "Content-Type": "multipart/form-data",
          authtoken: this.token.headers.authtoken,
        },
      };
      console.log(headers);
      // return;
      axios
        .post(globalStore.url + `product/createCompany`, formData, headers)
        .then((res) => {
          console.log("saved success", res);
          Swal.fire({
            icon: "success",
            title: "Your File has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
          this.Name = "";
          this.file = "";
          this.getAllMakers();
        })
        .catch((e) => {
          console.log("error saving file", e);
          Swal.fire("Oops...", "Something went wrong!", "error");
        });
    },
    getAllMakers() {
      axios
        .get(globalStore.url + `product/getCompanies`, this.token)
        .then((res) => {
          console.log("all Makers", res.data.data);
          this.Makers = res.data.data;
        })
        .catch((e) => {
          console.log("error getting all files", e);
        });
    },
    DeleteFile(maker) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          let data = {
            makerId: maker._id,
          };
          console.log(data);
          axios
            .put(globalStore.url + "product/delete-maker", data, this.token)
            .then((res) => {
              Swal.fire({
                icon: "success",
                title: "Maker is deleted",
                showConfirmButton: false,
                timer: 1500,
              });
              this.getAllMakers();
            })
            .catch((e) => {
              console.log("error deleteing", e);
              Swal.fire("Oops...", "Something went wrong!", "error");
            });
        }
      });
    },
    async changeLogo(maker, id) {
      let makerId = maker._id;
      let file = this.$refs[id][0].files[0];
      if(!makerId || !file) {
        return;
      }
      console.log(makerId)
      console.log(this.$refs)
      console.log(this.$refs[id][0].files[0])
      let formData = new FormData();
      formData.append("makerId", makerId);
      formData.append("photo", file);
      console.log("formData", formData);
      let headers = {
        headers: {
          "Content-Type": "multipart/form-data",
          authtoken: this.token.headers.authtoken,
        },
      };
      console.log(headers);
      // return;
      axios
        .put(globalStore.url + `product/maker-logo-update`, formData, headers)
        .then((res) => {
          console.log("saved success", res);
          Swal.fire({
            icon: "success",
            title: "Your image has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
          this.getAllMakers();
        })
        .catch((e) => {
          console.log("error saving file", e);
          Swal.fire("Oops...", "Something went wrong!", "error");
        });
      return;
    },
    changeImage(maker, id){
      document.getElementById(id).click()
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
img {
  width: 100px !important;
  height: 100px !important;
}
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.td-max-width {
  max-width: 200px !important;
  word-wrap: break-word;
  /* white-space: nowrap; 
  width: 50px; 
  overflow: hidden;
  text-overflow: ellipsis; */
}

.lds-ripple div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}

@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }

  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

.timeline-footer a.btn {
  margin-right: 10px;
}

tfoot input {
  width: 10%;
  padding: 3px;
  box-sizing: border-box;
}

.test {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// AddMakers.vue?20fc925d